import React, {useEffect} from "react";
import {Grid, Typography} from "@mui/material";
import useChallenge1Style from "../../styles/challengeUntold/challenge1";
import kozel_meeet from '../../assets/images/kozel_meet/meet_logo.png';
import untold_challenge_step_1 from '../../assets/images/untold/untold_challenge_step_1.png';
import TeaserFrame2 from "../TeaserFrame2";
import theme from "../../styles/themes/default";
import clsx from "clsx";
import {NavLink} from "react-router-dom";
import {paths} from "../../AppRouters";
import useActivity from "../../hooks/useActivity";

const Challenge1: React.FC = () => {
    const styles = useChallenge1Style();
    const {registerActivity} = useActivity();
    //
    useEffect(() => {
        registerActivity({
            name: 'UNTOLD_CHALLENGE_1',
            payload: {},
            callback: () => {},
        })
    }, []);

    return (
        <Grid container className={styles.container}>
            <Grid item xs={12} lg={6} className={styles.item}>
                <img src={kozel_meeet} alt={'kozel_meeet'} className={styles.logo} style={{maxWidth: '400px'}}/>
            </Grid>
            <Grid item xs={12} lg={6} className={styles.item}>
                <Typography className={styles.motoText}>There's always room for one more!</Typography>
            </Grid>
            <Grid item xs={12} lg={6} className={clsx(styles.item, styles.wrapperTeaserFrame)}>
                <TeaserFrame2
                    title={<Typography className={styles.teaserFrameTitle}>GOATIFUL!</Typography>}
                    backgroundBoxTitle={theme.colors.dark_chocolate}
                    titleMarginTop={'min(-5vh,-5vw)'}
                >
                    <Grid container className={styles.teaserContainer}>
                        <Grid item xs={12} className={styles.teaserItem}>
                            <Typography className={styles.accessText}>You accessed the 1st CHALLENGE!</Typography>
                        </Grid>
                        <Grid item xs={12} className={styles.teaserItem}>
                            <img src={untold_challenge_step_1} alt={'untold_challenge_step_1'}
                                 className={styles.imgStep}
                                 style={{maxWidth: '240px'}}/>
                        </Grid>
                        <Grid item xs={12} className={styles.teaserItem}>
                            <Typography className={styles.teaserTitle}>PUSH THE GOAT</Typography>
                        </Grid>
                        <Grid item xs={12} className={styles.teaserItem} flexDirection={'column'}>
                            <Typography className={styles.teaserText}>
                                Show your strength and dexterity in a game of precision and speed!
                            </Typography>
                            <Typography className={styles.teaserText}>
                                Compete against a team or have fun with friends and challenge each other.
                            </Typography>
                            <Typography className={styles.teaserText}>
                                You have to push the Kozel GOAT from the START line to the FINISH and back to the START line. Make sure you keep the GOAT in position and don't interfere with other players' space.
                            </Typography>
                            <Typography className={styles.teaserTextSuccess}><b>Good Luck!</b></Typography>
                        </Grid>
                    </Grid>
                </TeaserFrame2>
            </Grid>
            <Grid item xs={12} lg={4}>
                <Typography className={styles.prizesText}>Solving the first challenge brings 50 points to your group on kozel.ro</Typography>
            </Grid>
            <Grid item xs={12} lg={4}>
                <Typography className={styles.recommendGroupText}>Make sure you have your group formed - go to the
                    &nbsp;<NavLink to={paths.myGroup}>My Group</NavLink> section and invite your friends to the Kozel Meeet community!</Typography>
            </Grid>
        </Grid>
    )
}

export default Challenge1;